
import { mapGetters } from 'vuex';
import NewsUpdateModal from '@/components/ui/modal/NewsUpdateModal/NewsUpdateModal';

export default {
  name: 'NewsUpdateModalWrapper',
  components: {
    NewsUpdateModal,
  },
  computed: {
    ...mapGetters('authentication', ['profile']),
  },
  methods: {
    // TODO: this method is never called, and references this.tutorialStep,
    // this.birthdate, this.isLocalAccount and this.isValid, none of which are
    // defined anywhere in this component (no data(), no matching mapGetters).
    // Check whether it's still needed, fix it, or remove it.
    validate() {
      // TODO: check whether tutorialStep is still needed and remove it if not
      this.isValid =
        (this.tutorialStep == 0 && !!this.birthdate) || this.isLocalAccount;
    },
  },
};
